// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./material-icons.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  box-sizing: border-box;
}

body {
  overflow: hidden;
  font-display: fallback;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
}


/* Scrollbars */
::-webkit-scrollbar {
  width: 20px;
  height: 20px;
}

::-webkit-scrollbar-thumb {
  min-height: 40px;
  background-clip: padding-box;
  border: 5px solid transparent;
  border-radius: var(--radius-large);
  background-color: rgba(var(--scrollbar-background), 0.5);
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(var(--scrollbar-background), 0.75);
}


/* Global variables */

:root {
  --opacity-font: 0.65;
  --opacity-disabled: 0.5;

  --radius-small: 5px;
  --radius-medium: 10px;
  --radius-large: 15px;
  --radius-round: 50%;

  --z-index-sidebar-bg: -1;
  --z-index-dropdown: 2;
  --z-index-prompt: 3;
  --z-index-rmsc: 4;
  --z-index-mui-tooltip: 8;
  --z-index-print: 9;

  --header-height: 76px;
  --sidebar-width: 280px;
  --logobar-width: 280px;

  --button-bg: #eee;
  --select-bg: #fafafa;
  --button-bg-darker: #ddd;
  --separation-color: #aaa;
  --accent-color-red: 184, 1, 36;
  --accent-color: 3, 50, 155;
  --separation-color-light: #ccc;
  --scrollbar-background: 100, 100, 100;
  --favorite-color: 0, 124, 163;
  --nofavorite-color: 185, 185, 185;
}




/* ----- GLOBAL CUSTOM CSS ----- */

/* Layout */

.app {
  display: flex;
  flex-direction: column;

  width: 100vw;
  height: 100vh;
  max-width: 100%;
}

.body {
  flex-grow: 1;
  min-height: 0;
  display: flex;
  font-size: 85%;
}

.container {
  margin: 0px 10px 10px 10px;
  padding: 10px 20px 16px 20px;
  overflow: auto;
}

.checkbox {
  display: flex;
  align-items: center;

  margin: 0 15px;
  cursor: pointer;
}

.checkbox * {
  padding: 0 5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  accent-color: rgb(var(--accent-color));
}

.checkbox>input:disabled+label {
  opacity: 0.15;

}

h2 {
  font-size: 18px;
}

hr {
  height: 0;
  border: none;
  border-top: 2px solid #999;
  border-radius: var(--radius-small);
}


/* Buttons */

button {
  border: none;
  cursor: pointer;
  transition: 0.25s !important;
}

.button {
  padding: 6px 12px !important;
  background-color: var(--button-bg);
}

.button>* {
  transition: 0.25s;
}

.button>*:not(span[class*="material-icons"]) {
  font-weight: 600;
}

.button:not(:disabled):hover>* {
  color: rgb(var(--accent-color)) !important;
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}


/* Links */

a {
  text-decoration: none;
}

a:hover,
a:focus {
  text-decoration: underline;
}


/* Content Header */

.content__header {
  gap: 15px;
  margin: 0 10px;
  min-height: 56px;
  padding: 10px 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border: 1px solid var(--separation-color);
  background-color: var(--button-bg);
  border-radius: var(--radius-medium);
  box-shadow: 0px 0px 6px 1px var(--button-bg);
}

.content__header>h2 {
  display: flex;
  align-items: center;
  letter-spacing: -0.3px;
}

.content__header>.options {
  gap: 15px;
  display: flex;
}

.content__header>.options>* {
  gap: 10px;
  display: flex;
  max-height: 36px;
  align-items: center;
}

.button>.MuiButton-label>.MuiButton-startIcon>[class*="material-icons"] {
  font-size: 19px;
}

.content__header .button.icon {
  height: 36px;
  padding: 0 5px !important;

  display: flex;
  align-items: center;
}

.content__header .button.icon>* {
  color: #333;
}

.content__header a {
  color: inherit;
  text-decoration: none;
}

.content__header span[class*="material-icons"] {
  font-size: 25px;
}

.content__header .separation,
.MuiInputBase-adornedEnd .separation {
  border: 1px solid var(--separation-color);
  background-color: var(--separation-color);
}


/* Loader */

.loader {
  width: 100%;
  height: 100%;
  flex-grow: 1;

  display: grid;
  place-items: center;
}


/* Pop-up prompts */

.prompt__container {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;

  width: 70%;
  /*height: 90%;*/
  max-width: 640px;
  /*96px;*/
  max-height: 512px;
  border-radius: 12px;
  background-color: #fff;
}

.prompt__wrapper {
  gap: 20px;
  padding: 24px;
  overflow: hidden auto;

  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.prompt__container button:not(.button) {
  color: white;
  font-size: 14px;
  border: 1px solid transparent;
  border-radius: var(--radius-small);
  background-color: rgba(var(--accent-color), 204);
}

.prompt__container button:not(.button):hover,
.prompt__container button:not(.button):focus {
  transform: scale(1.02);
  background-color: rgba(var(--accent-color), 221);
}

.prompt__container .flexRow {
  gap: 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.prompt__container .flexRow.column {
  flex-direction: column;
}

.prompt__container .flexRow:not(.column)>* {
  width: 50%;
}

.prompt__container .flexRow>.radioRow>div {
  gap: 14px;
  flex-direction: row;
}

.prompt__container .flexRow>.radioRow>legend {
  line-height: 1;
}

.prompt__title {
  width: 100%;
  margin: 0 auto;
}

.prompt__title>h1 {
  text-align: center;
  margin: -12px auto 12px;
  color: rgba(var(--accent-color), 204);

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.prompt__title>h1~* {
  text-align: center;
}

.prompt__title>h1~* .singleSelect {
  max-width: 50%;
}

.prompt__content {
  gap: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.prompt__actions {
  padding: 24px;
  box-shadow: 0px -4px 4px -2px var(--button-bg-darker);
}


/* Pop-up prompt animation */
@keyframes backdrop {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes prompt {
  from {
    transform: translateY(50px);
  }

  to {
    transform: translateY(0);
  }
}

.prompt__backdrop.animated {
  animation: backdrop 0.33s;
}

.prompt__container.animated {
  animation: prompt 0.33s;
}


/* Pop-up prompt backdrop */
.prompt__backdrop {
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;

  inset: 0;
  z-index: var(--z-index-prompt);
  background-color: rgba(0, 0, 0, 0.5);
}


/* Top left logo */

.branding {
  padding: 10px;
  max-width: 33%;
  -webkit-user-select: none;
          user-select: none;
  width: var(--sidebar-width);

  gap: 10px;
  display: flex;
  align-items: center;
}

.branding>span {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.5px;
}


/* Regular Select */

.singleSelect {
  width: 100%;
  height: 34px;
  padding: 0 6px;
  max-width: 100%;

  outline: 0;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: 0.25s;
  font-family: inherit;
  color: rgb(var(--accent-color));
  border-radius: var(--radius-small);
  background-color: var(--select-bg);
  border: 1px solid var(--separation-color-light);
}

.singleSelect:not(:disabled):hover {
  border: 1px solid rgba(var(--accent-color), 136) !important;
}

.singleSelect:not(:disabled):focus {
  box-shadow: 0 0 0 1px rgb(var(--accent-color));
  border: 1px solid rgba(var(--accent-color), 136) !important;
}

.singleSelect>option {
  color: initial;
}

.singleSelect>menuitem {
  color: initial;
}


/* Multi select */

/* Opening animation */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

.sidebar__select {
  padding: 5px 10px;
  width: var(--sidebar-width);
  max-width: var(--sidebar-width);
}

.sidebar .sidebar__select {
  width: auto;
}

.sidebar__select.disabled {
  opacity: 0.66;
  cursor: no-drop;
}

.sidebar__select:not(.disabled) .dropdown-heading-value span {
  color: rgba(var(--accent-color), 204);
}

.rmsc.multi-select {
  --rmsc-h: 32px;
  --rmsc-p: 5px 5px 5px 10px;
  --rmsc-bg: var(--select-bg);
  --rmsc-radius: var(--radius-small);
  --rmsc-main: rgba(var(--accent-color), 88);
}

.rmsc.multi-select * {
  transition: 0.25s, color 0s, opacity 0s;
}

/* Select input field */
.rmsc.multi-select .dropdown-heading {
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
}

.rmsc.multi-select .dropdown-heading-value {
  padding: var(--rmsc-p);
}

.rmsc__arrow {
  color: #aaa;
}

.rmsc.multi-select button {
  background-color: transparent !important;
}


.rmsc.multi-select .dropdown-container:hover {
  border-color: var(--rmsc-main);
}

.rmsc.multi-select .dropdown-container[aria-expanded="true"] .rmsc__arrow {
  transform: rotateZ(180deg);
}

.rmsc.multi-select .dropdown-container[aria-disabled="true"],
select:disabled {
  opacity: 0.7;
  border: 1px solid var(--separation-color-light);
}

.rmsc.multi-select .dropdown-container[aria-disabled="true"] *,
select:disabled {
  cursor: no-drop;
}

.rmsc.multi-select .dropdown-container[aria-disabled="true"]:focus {
  box-shadow: none;
}

/* Select dropdown content */
.rmsc.multi-select .item-renderer {
  font-size: 10px;
  -webkit-user-select: none;
          user-select: none;

  display: flex;
  align-items: center;

  overflow: hidden;
  white-space: nowrap;
}

.rmsc.multi-select .item-renderer>span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.rmsc.multi-select .dropdown-content {
  animation: fadeIn 0.25s;
}

.rmsc.multi-select .panel-content .options {
  max-height: 160px;
}

.rmsc.multi-select .search input {
  padding: var(--rmsc-p);
}

.prompt__container .rmsc.multi-select .dropdown-content {
  z-index: var(--z-index-rmsc);
}


/* Tippy.js --- Tooltip component */

body [data-tippy-root] {
  /* Fix issue where the pop-up disappears before hovering it */
  margin: 0 -10px !important;
}

body .tippy-box {
  max-width: 360px !important;
  border-radius: var(--radius-medium) !important;
  box-shadow: 0 0 20px 10px rgb(154 160 174 / 25%), 0 4px 40px -8px rgb(35 40 45 / 50%) !important;
}

body .tippy-content {
  padding: 10px 15px !important;
}

body .tippy-content>div {
  gap: 5px;
  display: flex;
  flex-direction: column;
}


/* Material-UI custom styling --- adding "body" makes the custom styling higher in priority for CSS */
/* .MuiFilledSelect-root{
  background: greenyellow;
}

.MuiFilledInput-root{
  background: red;
}

.MuiTextField-root {
  background: greenyellow;
} */

body .MuiTextField-root .MuiInputLabel-outlined,
.MuiInputBase-adornedStart span[class*="material-icons"] {
  transition: 0.25s;
}

body .MuiInputLabel-root.Mui-focused,
body .MuiCheckbox-colorPrimary.Mui-checked,
body .MuiOutlinedInput-root.Mui-focused .material-icons-outlined {
  color: rgb(var(--accent-color)) !important;
}

body div[role="tooltip"] .MuiInputLabel-root.Mui-focused {
  color: #3f51b5 !important;
}

body .MuiOutlinedInput-root {
  border-radius: var(--radius-small);
}

body .MuiOutlinedInput-root fieldset {
  transition: 0.25s;
  border-width: 2px;
}

body .MuiOutlinedInput-root:hover fieldset {
  border-color: rgba(var(--accent-color), 0.5) !important;
}

body .MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: rgb(var(--accent-color)) !important;
}

body button.MuiButton-root {
  min-width: unset;
}

body button.MuiButton-root.Mui-disabled {
  opacity: 0.5;
  color: grey;
}

body button.MuiButton-root.Mui-disabled [class*="material-icons"] {
  color: initial;
}

/* Make primary buttons text bigger */
body button.MuiButton-root.btnPrimary>.MuiButton-label {
  transform: scale(1.1);
}

body button.MuiButton-root.btnDismiss {
  color: #f22;
  text-transform: none;
  background-color: transparent !important;
}

body button.MuiButton-root.btnSecondary {
  color: black;
  text-transform: none;
  border: 1px solid black;
  background-color: transparent !important;
}

body .MuiInputAdornment-root button[class*="MuiButton"] {
  padding: 0;
  color: unset;
  transform: unset;
  background-color: transparent;
}

body button .MuiButton-startIcon.MuiButton-iconSizeSmall {
  margin-left: 0;
}


/* DataGrid tables */

.datagrid__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-shadow: 0px -4px 4px -2px var(--button-bg-darker);
}

.MuiGridPanel-root {
  /* Make Grid pop-ups at the top-right */
  top: 157px !important;
  left: unset !important;
  right: 41px !important;
  transform: none !important;
  z-index: var(--mui-tooltip) !important;
}

body .content__header .MuiDataGrid-toolbarContainer {
  gap: 10px;
  padding: 0 !important;
}

body .MuiDataGrid-toolbarContainer .MuiButton-label {
  font-family: inherit;
}

body .MuiDataGrid-toolbarContainer .MuiButton-textSizeSmall {
  font-size: inherit;
}

body .MuiDataGrid-toolbarContainer .MuiButton-iconSizeSmall .MuiSvgIcon-root {
  font-size: 16px;
}

body .MuiDataGrid-root {
  font-weight: unset;
  font-family: unset;
  line-height: unset;
  letter-spacing: unset;
  border-radius: var(--radius-medium);
}

body .MuiDataGrid-root .content__header {
  margin: 10px;
  border-radius: var(--radius-small);
}

body .MuiDataGrid-root .MuiDataGrid-columnHeaderTitle {
  font-weight: 600;
}

body .MuiDataGrid-columnHeaderWrapper>*:focus-within,
body .MuiDataGrid-columnHeaderWrapper>*:focus,
body .MuiDataGrid-row>*:focus-within,
body .MuiDataGrid-row>*:focus {
  outline: 0 !important;
}

.datagrid-invisible {
  display: none !important;
}


/* Print reports */

#print {
  inset: -8px;
  /* cancel outside border-spacing */
  display: none;
  position: absolute;
  background: white;
  z-index: var(--z-index-print);
}

#print table {
  border-spacing: 8px;
}

#print .separation {
  width: 1px;
  border-left: 1px solid grey;
}

#print__logo {
  text-align: left;
}

#print th,
#print td {
  text-align: left;
}


/* React switch */

.react-switch-handle {
  box-shadow: none !important;
}

.react-switch-handle>div {
  display: flex;
}


/* Miscellaneous */

button,
span[class*="material-icons"] {
  -webkit-user-select: none;
          user-select: none;
}

.drag-handle {
  cursor: grab;
  font-size: 19px;
}

.drag-handle:active {
  cursor: grabbing;
}

.smooth-dnd-container.vertical {
  display: flex;
  min-height: auto;
  flex-direction: column;
}

.smooth-dnd-container>.smooth-dnd-draggable-wrapper {
  display: flex !important;
  overflow: hidden auto !important;
}





/* ----- END GLOBAL CUSTOM CSS ----- */`, "",{"version":3,"sources":["webpack://./src/Components/App.css"],"names":[],"mappings":"AAGA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,kFAAkF;AACpF;;;AAGA,eAAe;AACf;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,kCAAkC;EAClC,wDAAwD;AAC1D;;AAEA;EACE,yDAAyD;AAC3D;;;AAGA,qBAAqB;;AAErB;EACE,oBAAoB;EACpB,uBAAuB;;EAEvB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;;EAEnB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;;EAElB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;;EAEtB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,qCAAqC;EACrC,6BAA6B;EAC7B,iCAAiC;AACnC;;;;;AAKA,kCAAkC;;AAElC,WAAW;;AAEX;EACE,aAAa;EACb,sBAAsB;;EAEtB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,kCAAkC;AACpC;;;AAGA,YAAY;;AAEZ;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA,UAAU;;AAEV;EACE,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;;AAGA,mBAAmB;;AAEnB;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,yCAAyC;EACzC,kCAAkC;EAClC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;;EAEzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,yCAAyC;EACzC,yCAAyC;AAC3C;;;AAGA,WAAW;;AAEX;EACE,WAAW;EACX,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,mBAAmB;AACrB;;;AAGA,mBAAmB;;AAEnB;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;;EAE9B,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;;EAErB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;;EAEE,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;;EAErC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qDAAqD;AACvD;;;AAGA,4BAA4B;AAC5B;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;;AAGA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;;EAEvB,QAAQ;EACR,8BAA8B;EAC9B,oCAAoC;AACtC;;;AAGA,kBAAkB;;AAElB;EACE,aAAa;EACb,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;;EAE3B,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;;AAGA,mBAAmB;;AAEnB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;;EAEf,UAAU;EACV,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,8CAA8C;EAC9C,2DAA2D;AAC7D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA,iBAAiB;;AAEjB,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;EACZ,+CAA+C;AACjD;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;;EAEnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA,mCAAmC;;AAEnC;EACE,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,gGAAgG;AAClG;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;AACxB;;;AAGA,qGAAqG;AACrG;;;;;;;;;;GAUG;;AAEH;;EAEE,iBAAiB;AACnB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;;AAGA,oBAAoB;;AAEpB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA,kBAAkB;;AAElB;EACE,WAAW;EACX,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;;AAGA,iBAAiB;;AAEjB;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;;AAGA,kBAAkB;;AAElB;;EAEE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;;;;;AAMA,sCAAsC","sourcesContent":["@import \"./material-icons.css\";\r\n\r\n\r\n* {\r\n  margin: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  overflow: hidden;\r\n  font-display: fallback;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;\r\n}\r\n\r\n\r\n/* Scrollbars */\r\n::-webkit-scrollbar {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  min-height: 40px;\r\n  background-clip: padding-box;\r\n  border: 5px solid transparent;\r\n  border-radius: var(--radius-large);\r\n  background-color: rgba(var(--scrollbar-background), 0.5);\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background-color: rgba(var(--scrollbar-background), 0.75);\r\n}\r\n\r\n\r\n/* Global variables */\r\n\r\n:root {\r\n  --opacity-font: 0.65;\r\n  --opacity-disabled: 0.5;\r\n\r\n  --radius-small: 5px;\r\n  --radius-medium: 10px;\r\n  --radius-large: 15px;\r\n  --radius-round: 50%;\r\n\r\n  --z-index-sidebar-bg: -1;\r\n  --z-index-dropdown: 2;\r\n  --z-index-prompt: 3;\r\n  --z-index-rmsc: 4;\r\n  --z-index-mui-tooltip: 8;\r\n  --z-index-print: 9;\r\n\r\n  --header-height: 76px;\r\n  --sidebar-width: 280px;\r\n  --logobar-width: 280px;\r\n\r\n  --button-bg: #eee;\r\n  --select-bg: #fafafa;\r\n  --button-bg-darker: #ddd;\r\n  --separation-color: #aaa;\r\n  --accent-color-red: 184, 1, 36;\r\n  --accent-color: 3, 50, 155;\r\n  --separation-color-light: #ccc;\r\n  --scrollbar-background: 100, 100, 100;\r\n  --favorite-color: 0, 124, 163;\r\n  --nofavorite-color: 185, 185, 185;\r\n}\r\n\r\n\r\n\r\n\r\n/* ----- GLOBAL CUSTOM CSS ----- */\r\n\r\n/* Layout */\r\n\r\n.app {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  width: 100vw;\r\n  height: 100vh;\r\n  max-width: 100%;\r\n}\r\n\r\n.body {\r\n  flex-grow: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  font-size: 85%;\r\n}\r\n\r\n.container {\r\n  margin: 0px 10px 10px 10px;\r\n  padding: 10px 20px 16px 20px;\r\n  overflow: auto;\r\n}\r\n\r\n.checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  margin: 0 15px;\r\n  cursor: pointer;\r\n}\r\n\r\n.checkbox * {\r\n  padding: 0 5px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  accent-color: rgb(var(--accent-color));\r\n}\r\n\r\n.checkbox>input:disabled+label {\r\n  opacity: 0.15;\r\n\r\n}\r\n\r\nh2 {\r\n  font-size: 18px;\r\n}\r\n\r\nhr {\r\n  height: 0;\r\n  border: none;\r\n  border-top: 2px solid #999;\r\n  border-radius: var(--radius-small);\r\n}\r\n\r\n\r\n/* Buttons */\r\n\r\nbutton {\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: 0.25s !important;\r\n}\r\n\r\n.button {\r\n  padding: 6px 12px !important;\r\n  background-color: var(--button-bg);\r\n}\r\n\r\n.button>* {\r\n  transition: 0.25s;\r\n}\r\n\r\n.button>*:not(span[class*=\"material-icons\"]) {\r\n  font-weight: 600;\r\n}\r\n\r\n.button:not(:disabled):hover>* {\r\n  color: rgb(var(--accent-color)) !important;\r\n}\r\n\r\n.button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n/* Links */\r\n\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\na:hover,\r\na:focus {\r\n  text-decoration: underline;\r\n}\r\n\r\n\r\n/* Content Header */\r\n\r\n.content__header {\r\n  gap: 15px;\r\n  margin: 0 10px;\r\n  min-height: 56px;\r\n  padding: 10px 20px;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n\r\n  border: 1px solid var(--separation-color);\r\n  background-color: var(--button-bg);\r\n  border-radius: var(--radius-medium);\r\n  box-shadow: 0px 0px 6px 1px var(--button-bg);\r\n}\r\n\r\n.content__header>h2 {\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: -0.3px;\r\n}\r\n\r\n.content__header>.options {\r\n  gap: 15px;\r\n  display: flex;\r\n}\r\n\r\n.content__header>.options>* {\r\n  gap: 10px;\r\n  display: flex;\r\n  max-height: 36px;\r\n  align-items: center;\r\n}\r\n\r\n.button>.MuiButton-label>.MuiButton-startIcon>[class*=\"material-icons\"] {\r\n  font-size: 19px;\r\n}\r\n\r\n.content__header .button.icon {\r\n  height: 36px;\r\n  padding: 0 5px !important;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.content__header .button.icon>* {\r\n  color: #333;\r\n}\r\n\r\n.content__header a {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\n.content__header span[class*=\"material-icons\"] {\r\n  font-size: 25px;\r\n}\r\n\r\n.content__header .separation,\r\n.MuiInputBase-adornedEnd .separation {\r\n  border: 1px solid var(--separation-color);\r\n  background-color: var(--separation-color);\r\n}\r\n\r\n\r\n/* Loader */\r\n\r\n.loader {\r\n  width: 100%;\r\n  height: 100%;\r\n  flex-grow: 1;\r\n\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n\r\n/* Pop-up prompts */\r\n\r\n.prompt__container {\r\n  display: flex;\r\n  position: relative;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n\r\n  width: 70%;\r\n  /*height: 90%;*/\r\n  max-width: 640px;\r\n  /*96px;*/\r\n  max-height: 512px;\r\n  border-radius: 12px;\r\n  background-color: #fff;\r\n}\r\n\r\n.prompt__wrapper {\r\n  gap: 20px;\r\n  padding: 24px;\r\n  overflow: hidden auto;\r\n\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.prompt__container button:not(.button) {\r\n  color: white;\r\n  font-size: 14px;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--radius-small);\r\n  background-color: rgba(var(--accent-color), 204);\r\n}\r\n\r\n.prompt__container button:not(.button):hover,\r\n.prompt__container button:not(.button):focus {\r\n  transform: scale(1.02);\r\n  background-color: rgba(var(--accent-color), 221);\r\n}\r\n\r\n.prompt__container .flexRow {\r\n  gap: 12px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n}\r\n\r\n.prompt__container .flexRow.column {\r\n  flex-direction: column;\r\n}\r\n\r\n.prompt__container .flexRow:not(.column)>* {\r\n  width: 50%;\r\n}\r\n\r\n.prompt__container .flexRow>.radioRow>div {\r\n  gap: 14px;\r\n  flex-direction: row;\r\n}\r\n\r\n.prompt__container .flexRow>.radioRow>legend {\r\n  line-height: 1;\r\n}\r\n\r\n.prompt__title {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.prompt__title>h1 {\r\n  text-align: center;\r\n  margin: -12px auto 12px;\r\n  color: rgba(var(--accent-color), 204);\r\n\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.prompt__title>h1~* {\r\n  text-align: center;\r\n}\r\n\r\n.prompt__title>h1~* .singleSelect {\r\n  max-width: 50%;\r\n}\r\n\r\n.prompt__content {\r\n  gap: 20px;\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.prompt__actions {\r\n  padding: 24px;\r\n  box-shadow: 0px -4px 4px -2px var(--button-bg-darker);\r\n}\r\n\r\n\r\n/* Pop-up prompt animation */\r\n@keyframes backdrop {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes prompt {\r\n  from {\r\n    transform: translateY(50px);\r\n  }\r\n\r\n  to {\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.prompt__backdrop.animated {\r\n  animation: backdrop 0.33s;\r\n}\r\n\r\n.prompt__container.animated {\r\n  animation: prompt 0.33s;\r\n}\r\n\r\n\r\n/* Pop-up prompt backdrop */\r\n.prompt__backdrop {\r\n  display: flex;\r\n  position: fixed;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  inset: 0;\r\n  z-index: var(--z-index-prompt);\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n\r\n/* Top left logo */\r\n\r\n.branding {\r\n  padding: 10px;\r\n  max-width: 33%;\r\n  user-select: none;\r\n  width: var(--sidebar-width);\r\n\r\n  gap: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.branding>span {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  letter-spacing: -0.5px;\r\n}\r\n\r\n\r\n/* Regular Select */\r\n\r\n.singleSelect {\r\n  width: 100%;\r\n  height: 34px;\r\n  padding: 0 6px;\r\n  max-width: 100%;\r\n\r\n  outline: 0;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  transition: 0.25s;\r\n  font-family: inherit;\r\n  color: rgb(var(--accent-color));\r\n  border-radius: var(--radius-small);\r\n  background-color: var(--select-bg);\r\n  border: 1px solid var(--separation-color-light);\r\n}\r\n\r\n.singleSelect:not(:disabled):hover {\r\n  border: 1px solid rgba(var(--accent-color), 136) !important;\r\n}\r\n\r\n.singleSelect:not(:disabled):focus {\r\n  box-shadow: 0 0 0 1px rgb(var(--accent-color));\r\n  border: 1px solid rgba(var(--accent-color), 136) !important;\r\n}\r\n\r\n.singleSelect>option {\r\n  color: initial;\r\n}\r\n\r\n.singleSelect>menuitem {\r\n  color: initial;\r\n}\r\n\r\n\r\n/* Multi select */\r\n\r\n/* Opening animation */\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n.sidebar__select {\r\n  padding: 5px 10px;\r\n  width: var(--sidebar-width);\r\n  max-width: var(--sidebar-width);\r\n}\r\n\r\n.sidebar .sidebar__select {\r\n  width: auto;\r\n}\r\n\r\n.sidebar__select.disabled {\r\n  opacity: 0.66;\r\n  cursor: no-drop;\r\n}\r\n\r\n.sidebar__select:not(.disabled) .dropdown-heading-value span {\r\n  color: rgba(var(--accent-color), 204);\r\n}\r\n\r\n.rmsc.multi-select {\r\n  --rmsc-h: 32px;\r\n  --rmsc-p: 5px 5px 5px 10px;\r\n  --rmsc-bg: var(--select-bg);\r\n  --rmsc-radius: var(--radius-small);\r\n  --rmsc-main: rgba(var(--accent-color), 88);\r\n}\r\n\r\n.rmsc.multi-select * {\r\n  transition: 0.25s, color 0s, opacity 0s;\r\n}\r\n\r\n/* Select input field */\r\n.rmsc.multi-select .dropdown-heading {\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  user-select: none;\r\n  align-items: center;\r\n}\r\n\r\n.rmsc.multi-select .dropdown-heading-value {\r\n  padding: var(--rmsc-p);\r\n}\r\n\r\n.rmsc__arrow {\r\n  color: #aaa;\r\n}\r\n\r\n.rmsc.multi-select button {\r\n  background-color: transparent !important;\r\n}\r\n\r\n\r\n.rmsc.multi-select .dropdown-container:hover {\r\n  border-color: var(--rmsc-main);\r\n}\r\n\r\n.rmsc.multi-select .dropdown-container[aria-expanded=\"true\"] .rmsc__arrow {\r\n  transform: rotateZ(180deg);\r\n}\r\n\r\n.rmsc.multi-select .dropdown-container[aria-disabled=\"true\"],\r\nselect:disabled {\r\n  opacity: 0.7;\r\n  border: 1px solid var(--separation-color-light);\r\n}\r\n\r\n.rmsc.multi-select .dropdown-container[aria-disabled=\"true\"] *,\r\nselect:disabled {\r\n  cursor: no-drop;\r\n}\r\n\r\n.rmsc.multi-select .dropdown-container[aria-disabled=\"true\"]:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n/* Select dropdown content */\r\n.rmsc.multi-select .item-renderer {\r\n  font-size: 10px;\r\n  user-select: none;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rmsc.multi-select .item-renderer>span {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.rmsc.multi-select .dropdown-content {\r\n  animation: fadeIn 0.25s;\r\n}\r\n\r\n.rmsc.multi-select .panel-content .options {\r\n  max-height: 160px;\r\n}\r\n\r\n.rmsc.multi-select .search input {\r\n  padding: var(--rmsc-p);\r\n}\r\n\r\n.prompt__container .rmsc.multi-select .dropdown-content {\r\n  z-index: var(--z-index-rmsc);\r\n}\r\n\r\n\r\n/* Tippy.js --- Tooltip component */\r\n\r\nbody [data-tippy-root] {\r\n  /* Fix issue where the pop-up disappears before hovering it */\r\n  margin: 0 -10px !important;\r\n}\r\n\r\nbody .tippy-box {\r\n  max-width: 360px !important;\r\n  border-radius: var(--radius-medium) !important;\r\n  box-shadow: 0 0 20px 10px rgb(154 160 174 / 25%), 0 4px 40px -8px rgb(35 40 45 / 50%) !important;\r\n}\r\n\r\nbody .tippy-content {\r\n  padding: 10px 15px !important;\r\n}\r\n\r\nbody .tippy-content>div {\r\n  gap: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n\r\n/* Material-UI custom styling --- adding \"body\" makes the custom styling higher in priority for CSS */\r\n/* .MuiFilledSelect-root{\r\n  background: greenyellow;\r\n}\r\n\r\n.MuiFilledInput-root{\r\n  background: red;\r\n}\r\n\r\n.MuiTextField-root {\r\n  background: greenyellow;\r\n} */\r\n\r\nbody .MuiTextField-root .MuiInputLabel-outlined,\r\n.MuiInputBase-adornedStart span[class*=\"material-icons\"] {\r\n  transition: 0.25s;\r\n}\r\n\r\nbody .MuiInputLabel-root.Mui-focused,\r\nbody .MuiCheckbox-colorPrimary.Mui-checked,\r\nbody .MuiOutlinedInput-root.Mui-focused .material-icons-outlined {\r\n  color: rgb(var(--accent-color)) !important;\r\n}\r\n\r\nbody div[role=\"tooltip\"] .MuiInputLabel-root.Mui-focused {\r\n  color: #3f51b5 !important;\r\n}\r\n\r\nbody .MuiOutlinedInput-root {\r\n  border-radius: var(--radius-small);\r\n}\r\n\r\nbody .MuiOutlinedInput-root fieldset {\r\n  transition: 0.25s;\r\n  border-width: 2px;\r\n}\r\n\r\nbody .MuiOutlinedInput-root:hover fieldset {\r\n  border-color: rgba(var(--accent-color), 0.5) !important;\r\n}\r\n\r\nbody .MuiOutlinedInput-root.Mui-focused fieldset {\r\n  border-color: rgb(var(--accent-color)) !important;\r\n}\r\n\r\nbody button.MuiButton-root {\r\n  min-width: unset;\r\n}\r\n\r\nbody button.MuiButton-root.Mui-disabled {\r\n  opacity: 0.5;\r\n  color: grey;\r\n}\r\n\r\nbody button.MuiButton-root.Mui-disabled [class*=\"material-icons\"] {\r\n  color: initial;\r\n}\r\n\r\n/* Make primary buttons text bigger */\r\nbody button.MuiButton-root.btnPrimary>.MuiButton-label {\r\n  transform: scale(1.1);\r\n}\r\n\r\nbody button.MuiButton-root.btnDismiss {\r\n  color: #f22;\r\n  text-transform: none;\r\n  background-color: transparent !important;\r\n}\r\n\r\nbody button.MuiButton-root.btnSecondary {\r\n  color: black;\r\n  text-transform: none;\r\n  border: 1px solid black;\r\n  background-color: transparent !important;\r\n}\r\n\r\nbody .MuiInputAdornment-root button[class*=\"MuiButton\"] {\r\n  padding: 0;\r\n  color: unset;\r\n  transform: unset;\r\n  background-color: transparent;\r\n}\r\n\r\nbody button .MuiButton-startIcon.MuiButton-iconSizeSmall {\r\n  margin-left: 0;\r\n}\r\n\r\n\r\n/* DataGrid tables */\r\n\r\n.datagrid__footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  box-shadow: 0px -4px 4px -2px var(--button-bg-darker);\r\n}\r\n\r\n.MuiGridPanel-root {\r\n  /* Make Grid pop-ups at the top-right */\r\n  top: 157px !important;\r\n  left: unset !important;\r\n  right: 41px !important;\r\n  transform: none !important;\r\n  z-index: var(--mui-tooltip) !important;\r\n}\r\n\r\nbody .content__header .MuiDataGrid-toolbarContainer {\r\n  gap: 10px;\r\n  padding: 0 !important;\r\n}\r\n\r\nbody .MuiDataGrid-toolbarContainer .MuiButton-label {\r\n  font-family: inherit;\r\n}\r\n\r\nbody .MuiDataGrid-toolbarContainer .MuiButton-textSizeSmall {\r\n  font-size: inherit;\r\n}\r\n\r\nbody .MuiDataGrid-toolbarContainer .MuiButton-iconSizeSmall .MuiSvgIcon-root {\r\n  font-size: 16px;\r\n}\r\n\r\nbody .MuiDataGrid-root {\r\n  font-weight: unset;\r\n  font-family: unset;\r\n  line-height: unset;\r\n  letter-spacing: unset;\r\n  border-radius: var(--radius-medium);\r\n}\r\n\r\nbody .MuiDataGrid-root .content__header {\r\n  margin: 10px;\r\n  border-radius: var(--radius-small);\r\n}\r\n\r\nbody .MuiDataGrid-root .MuiDataGrid-columnHeaderTitle {\r\n  font-weight: 600;\r\n}\r\n\r\nbody .MuiDataGrid-columnHeaderWrapper>*:focus-within,\r\nbody .MuiDataGrid-columnHeaderWrapper>*:focus,\r\nbody .MuiDataGrid-row>*:focus-within,\r\nbody .MuiDataGrid-row>*:focus {\r\n  outline: 0 !important;\r\n}\r\n\r\n.datagrid-invisible {\r\n  display: none !important;\r\n}\r\n\r\n\r\n/* Print reports */\r\n\r\n#print {\r\n  inset: -8px;\r\n  /* cancel outside border-spacing */\r\n  display: none;\r\n  position: absolute;\r\n  background: white;\r\n  z-index: var(--z-index-print);\r\n}\r\n\r\n#print table {\r\n  border-spacing: 8px;\r\n}\r\n\r\n#print .separation {\r\n  width: 1px;\r\n  border-left: 1px solid grey;\r\n}\r\n\r\n#print__logo {\r\n  text-align: left;\r\n}\r\n\r\n#print th,\r\n#print td {\r\n  text-align: left;\r\n}\r\n\r\n\r\n/* React switch */\r\n\r\n.react-switch-handle {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.react-switch-handle>div {\r\n  display: flex;\r\n}\r\n\r\n\r\n/* Miscellaneous */\r\n\r\nbutton,\r\nspan[class*=\"material-icons\"] {\r\n  user-select: none;\r\n}\r\n\r\n.drag-handle {\r\n  cursor: grab;\r\n  font-size: 19px;\r\n}\r\n\r\n.drag-handle:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.smooth-dnd-container.vertical {\r\n  display: flex;\r\n  min-height: auto;\r\n  flex-direction: column;\r\n}\r\n\r\n.smooth-dnd-container>.smooth-dnd-draggable-wrapper {\r\n  display: flex !important;\r\n  overflow: hidden auto !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* ----- END GLOBAL CUSTOM CSS ----- */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
